import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { ErrorHead } from '@layouts/Error-Head';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const ErrorLayout = ({ title, children, isHidePage = false, meta = null }) => (
  <>
    <GlobalStyle />
    <ErrorHead title={title} isHidePage={isHidePage} meta={meta} />
    {children}
  </>
);

const GlobalStyle = createGlobalStyle`
  body {
    min-width: 320px;
    background-color: ${Colors.white};
  }
`;
